module.exports = __webpack_public_path__ + "static/media/jasper-52.35029651.jpg";